export default "__VITE_ASSET__DlqeiuQP__"